<template>
  <section>
    <div class="container">
      <div v-show="nezet.tipus == 'kitoltesek'">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">
              Rendszeres szociális ösztöndíj pályázataim
            </div>
            <div class="article-text">
              <div class="info-box" v-for="(kitoltes, i) in kitoltesek">
                <div class="title">{{ kitoltes.tanulmanyiFelev }}</div>
                <div style="display: flex; flex-direction: column; align-items: flex-start;">
                  <button v-if="kitoltes.tanulmanyiFelev != '2023/2024/1' && ![0].includes(parseInt(kitoltes.statusz))" style="margin-top: 5px" :disabled="pdf_generalas_folyamatban" @click="pdfGeneralas(kitoltes.id, 1)" type="button" class="button">Beadott pályázatom (Pdf)</button>
                  <button v-if="[4, 6].includes(parseInt(kitoltes.statusz))" style="margin-top: 5px" :disabled="pdf_generalas_folyamatban" @click="pdfGeneralas(kitoltes.id, 0)" type="button" class="button">Elbírált pályázatom ({{kitoltes.osszPontszam}} pont) (Pdf)</button>
                  <button v-if="kitoltes.email != false" style="margin-top: 5px" type="button" :disabled="pdf_generalas_folyamatban" @click="emailPopupNyit(kitoltes.email)" class="button with-icon"><i class="fa fa-envelope"></i>Email tartalma</button>
                  <div v-if="[0].includes(parseInt(kitoltes.statusz))">Nem található végelegesített pályázat.</div>
                </div>
              </div>
            </div>
            <div style="padding-top: 30px" v-if="tanulmanyiFelev != false">
              <div class="form-title">
                Rendszeres szociális ösztöndíj {{tanulmanyiFelev}}
              </div>
              <div class="article-text">
                <div style="display: flex; flex-direction: column; align-items: flex-start;">
                  <button :disabled="pdf_generalas_folyamatban" v-if="aktiv_idoszak_kitoltes != false && ![0].includes(parseInt(aktiv_idoszak_kitoltes.statusz))" @click="pdfGeneralas(aktiv_idoszak_kitoltes.id, 1)" type="button" class="button">Beadott pályázatom (Pdf)</button>
                  <button style="margin-top: 5px" :disabled="pdf_generalas_folyamatban" v-if="aktiv_idoszak_kitoltes != false && [4, 6].includes(parseInt(aktiv_idoszak_kitoltes.statusz))" @click="pdfGeneralas(aktiv_idoszak_kitoltes.id, 0)" type="button" class="button">Elbírált pályázatom ({{aktiv_idoszak_kitoltes.osszPontszam}} pont) (Pdf)</button>
                  <button v-if="aktiv_idoszak_kitoltes != false && aktiv_idoszak_kitoltes.email != false" :disabled="pdf_generalas_folyamatban" style="margin-top: 5px" type="button" @click="emailPopupNyit(aktiv_idoszak_kitoltes.email)" class="button with-icon"><i class="fa fa-envelope"></i>Email tartalma</button>

                  <button :disabled="pdf_generalas_folyamatban" style="margin-top: 5px" v-if="aktiv_idoszak_kitoltes == false && k_kitoltes" @click="palyazatElfogadas()" type="button" class="button">{{ tanulmanyiFelev }}/K pályázat eredményének elfogadása</button>
                  <button :disabled="pdf_generalas_folyamatban" style="margin-top: 5px" v-if="aktiv_idoszak_kitoltes == false && k_kitoltes" @click="palyazatModositasa()" type="button" class="button">{{ tanulmanyiFelev }}/K pályázat módosítása</button>
                  <button :disabled="pdf_generalas_folyamatban" style="margin-top: 5px" v-if="aktiv_idoszak_kitoltes == false || (aktiv_idoszak_kitoltes != false && [0].includes(parseInt(aktiv_idoszak_kitoltes.statusz)))" @click="palyazatUrlapMegjelenites()" type="button" class="button">Új pályázat leadása</button>
                </div>
              </div>
            </div>

            <div style="padding-top: 30px" v-if="aktiv_hianypotlas_idoszak != false && hianypotlasra_varo_kitoltes !== false">
              <div class="form-title">
                Rendszeres szociális ösztöndíj {{aktiv_hianypotlas_idoszak}} hiánypótlás
              </div>
              <div class="article-text">
                Az Ön pályázatához hiánypótlás szükséges.
                <div style="display: flex; flex-direction: column; align-items: flex-start; padding-top: 20px">
                  <button :disabled="pdf_generalas_folyamatban" style="margin-top: 5px" @click="hianypotlasUrlapMegjelenites()" type="button" class="button">Hiánypótlás űrlap megnyitása</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="nezet.tipus == 'urlap'">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">
              Rendszeres szociális ösztöndíj
            </div>
          </div>

          <div class="col-xs-12">
            <div class="info-box warning">
              Amennyiben hibát talál <span class="highlight">személyes</span> vagy <span class="highlight">képzési adataiban</span>, kérjük lépjen kapcsolatba a tanulmányi ügyintézővel.
            </div>
          </div>

          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Személyes adatok
            </h5>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="nev" name="nev" disabled label="Név" v-model="form.nev"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="neptunkod" name="neptunkod" disabled label="Neptun azonosító" v-model="form.neptunkod"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="szuletesiHely" name="szuletesiHely" disabled label="Születési hely" v-model="form.szuletesiHely"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="szuletesiIdo" name="szuletesiIdo" disabled label="Születési idő" v-model="form.szuletesiIdo"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="anyjaNeve" name="anyjaNeve" disabled label="Anyja neve" v-model="form.anyjaNeve"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="telefonszam" name="telefonszam" disabled label="Telefonszám" v-model="form.telefonszam"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="emailCim" name="emailCim" disabled label="E-mail cím" v-model="form.emailCim"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Képzési adatok
            </h5>
          </div>
          <div class="col-xs-12">
            <comboboxV2 :errors="errors" @onChange="kepzesValt" label="Képzések" id="kivalasztottKepzesKodja" :options="kepzesek" v-model="form.kivalasztottKepzesKodja"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kar" name="kar" disabled label="Kar neve" v-model="form.kar"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="tagozat" name="tagozat" disabled label="Tagozat" v-model="form.tagozat"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesNeve" name="kepzesNeve" disabled label="Képzés" v-model="form.kepzesNeve"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesKodja" name="kepzesKodja" disabled label="Képzés kódja" v-model="form.kepzesKodja"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesSzintje" name="kepzesSzintje" disabled label="Képzés szintje" v-model="form.kepzesSzintje"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="hallgatoiStatusz" name="hallgatoiStatusz" disabled label="Hallgatói státusz" v-model="form.hallgatoiStatusz"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="kepzesHelye" name="kepzesHelye" disabled label="Képzés helye" v-model="form.kepzesHelye"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="penzugyiStatusz" name="penzugyiStatusz" disabled label="Pénzügyi státusz" v-model="form.penzugyiStatusz"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="osztondijindex" name="osztondijindex" disabled label="Ösztöndíjindex" v-model="form.osztondijindex"/>
          </div>
          <div class="col-xs-6" style="display: none">
            <inputbox :errors="errors" id="szakatlag" name="szakatlag" disabled label="Szakátlag" v-model="form.szakatlag"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Igényelt támogatások
            </h5>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper" :class="{disabled: alaptamogatasDisabled()}">
                <input :disabled="alaptamogatasDisabled()" id="alapTamogatas" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.alapTamogatas"/>
                <label for="alapTamogatas">
                  <div class="icon"></div>
                  Alaptámogatás
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper" :class="{disabled: rendszeresSzocialisOsztondijDisabled()}">
                <input :disabled="rendszeresSzocialisOsztondijDisabled()" id="rendszeresSzocialisOsztondij" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.rendszeresSzocialisOsztondij"/>
                <label for="rendszeresSzocialisOsztondij">
                  <div class="icon"></div>
                  Rendszeres szociális ösztöndíj
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper" :class="{disabled: lakhatasiTamogatasDisabled()}">
                <input :disabled="lakhatasiTamogatasDisabled()" id="lakhatasiTamogatas" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.lakhatasiTamogatas"/>
                <label for="lakhatasiTamogatas">
                  <div class="icon"></div>
                  Lakhatási támogatás
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper" :class="{disabled: koltsegteritesMerseklesDisabled()}">
                <input :disabled="koltsegteritesMerseklesDisabled()" id="koltsegteritesMersekles" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.koltsegteritesMersekles"/>
                <label for="koltsegteritesMersekles">
                  <div class="icon"></div>
                  Költségtérítés-mérséklés tevékenység alapon
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper" :class="{disabled: koltsegteritesMerseklesSzocialisAlaponDisabled()}">
                <input :disabled="koltsegteritesMerseklesSzocialisAlaponDisabled()" id="koltsegteritesMerseklesSzocialisAlapon" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.koltsegteritesMerseklesSzocialisAlapon"/>
                <label for="koltsegteritesMerseklesSzocialisAlapon">
                  <div class="icon"></div>
                  Költségtérítés-mérséklés szociális alapon
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper disabled">
                <input :disabled="true" id="onkoltsegesKollegiumiPontszam" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.onkoltsegesKollegiumiPontszam"/>
                <label for="onkoltsegesKollegiumiPontszam">
                  <div class="icon"></div>
                  Önköltségeseknek kollégiumi pontszám
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-show="form.koltsegteritesMersekles == 1 ? true : false">
          <div class="col-xs-12">
            <UploadHandler max_uploaded_files="1" @change="(value) => { form.koltsegteritesMerseklesKiemelkedoTevekenysegIgazolasa = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="koltsegteritesMerseklesKiemelkedoTevekenysegIgazolasa" label="Kiemelkedő tevékenység igazolása a költségtérítés mérsékléshez" name="koltsegteritesMerseklesKiemelkedoTevekenysegIgazolasa" :loaded_files="form.koltsegteritesMerseklesKiemelkedoTevekenysegIgazolasa"/>
          </div>
          <div class="col-xs-12">
            <textareabox :errors="errors" id="koltsegteritesMerseklesIndoklas" label="Költségtérítés mérséklési kérelem indoklása" name="koltsegteritesMerseklesIndoklas" v-model="form.koltsegteritesMerseklesIndoklas"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              A pályázó állandó lakhelyének távolsága a képzés helyétől
            </h5>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="allandoLakhelyOrszag" name="allandoLakhelyOrszag" disabled label="Ország" v-model="form.allandoLakhelyOrszag"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="allandoLakhelyIranyitoszam" name="allandoLakhelyIranyitoszam" disabled label="Irányítószám" v-model="form.allandoLakhelyIranyitoszam"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="allandoLakhelyTelepules" name="allandoLakhelyTelepules" disabled label="Település" v-model="form.allandoLakhelyTelepules"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="allandoLakhelyCim" name="allandoLakhelyCim" disabled label="Cím" v-model="form.allandoLakhelyCim"/>
          </div>
          <div class="col-xs-12">
            <inputbox :errors="errors" id="allandoLakhelyTavolsagKepzesHelyetolKm" name="allandoLakhelyTavolsagKepzesHelyetolKm" disabled label="Állandó lakhely távolsága (km) a képzés helyétől" v-model="form.allandoLakhelyTavolsagKepzesHelyetolKm"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="utazasiIdoAllandoLakhelyKepzesHelyetolOra" name="utazasiIdoAllandoLakhelyKepzesHelyetolOra" disabled label="Utazási idő (óra) az állandó lakhelytől a képzés helyéig" v-model="form.utazasiIdoAllandoLakhelyKepzesHelyetolOra"/>
          </div>
          <div class="col-xs-6">
            <inputbox :errors="errors" id="utazasiIdoAllandoLakhelyKepzesHelyetolPerc" name="utazasiIdoAllandoLakhelyKepzesHelyetolPerc" disabled label="Utazási idő (perc) az állandó lakhelytől a képzés helyéig" v-model="form.utazasiIdoAllandoLakhelyKepzesHelyetolPerc"/>
          </div>
          <div class="col-xs-12">
            <div class="info-box download">
              <a target="_blank" href="assets/files/rendszeres_szocialis_osztondij_1_sz_melleklet.pdf" title="1. sz. melléklet">
                <span class="highlight">1. sz. melléklet (Kérelem egy lakcímen bejelentett személyek igazolásához minta)</span> letöltés
              </a>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.egyhaztartasbanElokIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="egyhaztartasbanElokIgazolas" label="Hatósági igazolás az egy háztartásban élőkről" name="egyhaztartasbanElokIgazolas" :loaded_files="form.egyhaztartasbanElokIgazolas"/>
            </div>
          </div>
          <div class="col-xs-12" v-show="form.kollegiumiFerohely == 1 ? false : true">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input @change="() => { lakhatasiTamogatasJeloles(); }" id="lakhatasiCeluAlberletiSzezodes" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.lakhatasiCeluAlberletiSzezodes"/>
                <label for="lakhatasiCeluAlberletiSzezodes">
                  <div class="icon"></div>
                  Lakhatási célú albérleti szerződéssel rendelkezem
                </label>
              </div>
              <div v-for="error in errors" v-if="error.id == 'lakhatasiCeluAlberletiSzezodes'" class="form-error">{{ error.msg }}</div>
            </div>
          </div>
          <div class="col-xs-12" v-show="form.lakhatasiCeluAlberletiSzezodes == 1 && form.kollegiumiFerohely == 0 ? true : false">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.lakhatasiCeluAlberletiSzezodesIgazolas = value; lakhatasiTamogatasJeloles(); }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="lakhatasiCeluAlberletiSzezodesIgazolas" label="Albérleti szerződés igazolás" name="lakhatasiCeluAlberletiSzezodesIgazolas" :loaded_files="form.lakhatasiCeluAlberletiSzezodesIgazolas"/>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper disabled">
                <input disabled true-value="1" false-value="0" id="kollegiumiFerohely" type="checkbox" value="1" v-model="form.kollegiumiFerohely"/>
                <label for="kollegiumiFerohely">
                  <div class="icon"></div>
                  Kollégiumi férőhely
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Szociális rászorultság - családi állapot
            </h5>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input id="szocialisRaszorultsagArva" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.szocialisRaszorultsagArva"/>
                <label for="szocialisRaszorultsagArva">
                  <div class="icon"></div>
                  Árva
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input id="szocialisRaszorultsagFelarva" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.szocialisRaszorultsagFelarva"/>
                <label for="szocialisRaszorultsagFelarva">
                  <div class="icon"></div>
                  Félárva
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input id="szocialisRaszorultsagCsaladfenntarto" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.szocialisRaszorultsagCsaladfenntarto"/>
                <label for="szocialisRaszorultsagCsaladfenntarto">
                  <div class="icon"></div>
                  Családfenntartó
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input id="szocialisRaszorultsagGyamsagaMegszunt" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.szocialisRaszorultsagGyamsagaMegszunt"/>
                <label for="szocialisRaszorultsagGyamsagaMegszunt">
                  <div class="icon"></div>
                  Gyámsága nagykorúsága miatt szűnt meg
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input id="szocialisRaszorultsagHatranyosHelyzetu" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.szocialisRaszorultsagHatranyosHelyzetu"/>
                <label for="szocialisRaszorultsagHatranyosHelyzetu">
                  <div class="icon"></div>
                  Hátrányos helyzetű
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input id="szocialisRaszorultsagFogyatkossaggalElo" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.szocialisRaszorultsagFogyatkossaggalElo"/>
                <label for="szocialisRaszorultsagFogyatkossaggalElo">
                  <div class="icon"></div>
                  Fogyatékossággal élő
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input id="szocialisRaszorultsagHalmozottanHatranyosHelyzetu" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu"/>
                <label for="szocialisRaszorultsagHalmozottanHatranyosHelyzetu">
                  <div class="icon"></div>
                  Halmozottan hátrányos helyzetű
                </label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input id="szocialisRaszorultsagTartosBeteg" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.szocialisRaszorultsagTartosBeteg"/>
                <label for="szocialisRaszorultsagTartosBeteg">
                  <div class="icon"></div>
                  Tartós beteg
                </label>
              </div>
              <div v-if="error.id == 'szocialisRaszorultsagTartosBeteg'" v-for="error in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <div class="form-checkbox-wrapper disabled">
                <input :disabled="true" id="szocialisRaszorultsagNagycsalados" true-value="1" false-value="0" type="checkbox" value="1" v-model="form.szocialisRaszorultsagNagycsalados"/>
                <label for="szocialisRaszorultsagNagycsalados">
                  <div class="icon"></div>
                  Nagycsaládos
                </label>
              </div>
              <div v-if="error.id == 'szocialisRaszorultsagNagycsalados'" v-for="error in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>

          <div class="col-xs-12" v-show="form.szocialisRaszorultsagNagycsalados == 1 ? true : false">
            <div class="info-box warning">
              A nagycsaládos helyzet igazolásához legalább két eltartott testvér esetén születési anyakönyvi kivonat, diákigazolvány másolat vagy hallgatói jogviszony igazolás szükséges; három gyermek esetén az anyakönyvi kivonatok másolatai szükségesek; eltartóin (eltartóján) kívül legalább két vele egy háztartásban élő személyre igaz, hogy havi jövedelme nem éri el a minimálbér összegét, mely esetén jövedelemigazolások szükségesek, vagy igazolás arról, hogy nem rendelkezik jövedelemmel (például: kiskorú, tanuló, hallgató munkanélküli); legalább két kiskorú gyermeknek a gyámja, mely esetén gyámsági igazolás szükséges.
            </div>
          </div>

          <div class="col-xs-12" v-show="form.szocialisRaszorultsagArva == 1 ? true : false">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.szocialisRaszorultsagArvaIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szocialisRaszorultsagArvaIgazolas" label="Árva igazolás" name="szocialisRaszorultsagArvaIgazolas" :loaded_files="form.szocialisRaszorultsagArvaIgazolas"/>
            </div>
          </div>
          <div class="col-xs-12" v-show="form.szocialisRaszorultsagFelarva == 1 ? true : false">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.szocialisRaszorultsagFelarvaIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szocialisRaszorultsagFelarvaIgazolas" label="Félárva igazolás" name="szocialisRaszorultsagFelarvaIgazolas" :loaded_files="form.szocialisRaszorultsagFelarvaIgazolas"/>
            </div>
          </div>
          <div class="col-xs-12" v-show="form.szocialisRaszorultsagCsaladfenntarto == 1 ? true : false">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.szocialisRaszorultsagCsaladfenntartoIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szocialisRaszorultsagCsaladfenntartoIgazolas" label="Családfenntartó igazolás" name="szocialisRaszorultsagCsaladfenntartoIgazolas" :loaded_files="form.szocialisRaszorultsagCsaladfenntartoIgazolas"/>
            </div>
          </div>
          <div class="col-xs-12" v-show="form.szocialisRaszorultsagGyamsagaMegszunt == 1 ? true : false">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.szocialisRaszorultsagGyamsagaMegszuntIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szocialisRaszorultsagGyamsagaMegszuntIgazolas" label="Gyámsága nagykorúsága miatt szűnt meg igazolás" name="szocialisRaszorultsagGyamsagaMegszuntIgazolas" :loaded_files="form.szocialisRaszorultsagGyamsagaMegszuntIgazolas"/>
            </div>
          </div>
          <div class="col-xs-12" v-show="form.szocialisRaszorultsagHatranyosHelyzetu == 1 ? true : false">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.szocialisRaszorultsagHatranyosHelyzetuIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szocialisRaszorultsagHatranyosHelyzetuIgazolas" label="Hátrányos helyzetű igazolás" name="szocialisRaszorultsagHatranyosHelyzetuIgazolas" :loaded_files="form.szocialisRaszorultsagHatranyosHelyzetuIgazolas"/>
            </div>
          </div>
          <div class="col-xs-12" v-show="form.szocialisRaszorultsagFogyatkossaggalElo == 1 ? true : false">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.szocialisRaszorultsagFogyatkossaggalEloIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szocialisRaszorultsagFogyatkossaggalEloIgazolas" label="Fogyatékossággal élő igazolás" name="szocialisRaszorultsagFogyatkossaggalEloIgazolas" :loaded_files="form.szocialisRaszorultsagFogyatkossaggalEloIgazolas"/>
            </div>
          </div>
          <div class="col-xs-12" v-show="form.szocialisRaszorultsagHalmozottanHatranyosHelyzetu == 1 ? true : false">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.szocialisRaszorultsagHalmozottanHatranyosHelyzetuIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szocialisRaszorultsagHalmozottanHatranyosHelyzetuIgazolas" label="Halmozottan hátrányos helyzetű igazolás" name="szocialisRaszorultsagHalmozottanHatranyosHelyzetuIgazolas" :loaded_files="form.szocialisRaszorultsagHalmozottanHatranyosHelyzetuIgazolas"/>
            </div>
          </div>
          <div class="col-xs-12" v-show="form.szocialisRaszorultsagTartosBeteg == 1 ? true : false">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.szocialisRaszorultsagTartosBetegIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szocialisRaszorultsagTartosBetegIgazolas" label="Tartós beteg igazolás" name="szocialisRaszorultsagTartosBetegIgazolas" :loaded_files="form.szocialisRaszorultsagTartosBetegIgazolas"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Pályázóval közös háztartásban élők havi nettó jövedelme
            </h5>
          </div>

          <div class="col-xs-12">
            <div class="info-box warning">
              {{ konfigAdat('EURO_ARFOLYAM').megnevezes }}: <strong>{{ konfigAdat('EURO_ARFOLYAM').ertek_ }} Ft</strong><br>
              {{ konfigAdat('DOLLAR_ARFOLYAM').megnevezes }}: <strong>{{ konfigAdat('DOLLAR_ARFOLYAM').ertek_ }} Ft</strong><br>
              {{ konfigAdat('MINIMALBER').megnevezes }}: <strong>{{ konfigAdat('MINIMALBER').ertek_ }} Ft</strong>
            </div>
          </div>

          <div class="col-xs-12">
            <table class="list-table">
              <tr>
                <th align="left">Teljes név</th>
                <th align="left">Rokonsági fok</th>
                <th align="left">Foglalkozás</th>
                <th align="left">Havi nettó jövedelem (Ft)</th>
                <th align="left">Nem él velem<br>egy háztartásban</th>
                <th></th>
              </tr>
              <tr :key="'kozoshaztartasbanElo_'+i" v-for="(kozoshaztartasbanElo, i) in form.kozosHaztartasbanElokLista">
                <td>
                  <inputbox style="padding-bottom: 0px" :disabled="i == 0" :errors="errors" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+" :id="'nev_'+i" label="" :name="'nev_'+i" v-model="kozoshaztartasbanElo.nev"/>
                </td>
                <td>
                  <inputbox style="padding-bottom: 0px" :disabled="i == 0" :errors="errors" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ ]+" :id="'rokonsagiFok_'+i" label="" :name="'rokonsagiFok_'+i" v-model="kozoshaztartasbanElo.rokonsagiFok"/>
                </td>
                <td>
                  <comboboxV2 style="padding-bottom: 0px" :disabled="i == 0" :errors="errors" label="" :id="'foglalkozas_'+i" :options="foglalkozas_tipusok" v-model="kozoshaztartasbanElo.tipus"/>
                </td>
                <td>
                  <inputbox @input="egyForeJutoNettoHaviJovedelemKalkulacio" style="padding-bottom: 0px" regexp_filter="[0-9]+" :id="'haviNettoJovedelem_'+i" :errors="errors" label="" :name="'haviNettoJovedelem_'+i" v-model="kozoshaztartasbanElo.haviNettoJovedelem"/>
                </td>
                <td>
                  <div class="form-checkbox-wrapper" :class="{disabled: i == 0 ? true : false}">
                    <input @change="egyForeJutoNettoHaviJovedelemKalkulacio" :disabled="i == 0" :id="'nemElVelemEgyHaztartasban_'+i" true-value="1" false-value="0" type="checkbox" value="0" v-model="kozoshaztartasbanElo.nemElVelemEgyHaztartasban"/>
                    <label :for="'nemElVelemEgyHaztartasban_'+i">
                      <div class="icon"></div>
                    </label>
                  </div>
                </td>
                <td>
                  <button v-if="i > 0" @click="kozosHaztartasbanElokListabolTorol(i)" type="button" class="button only-icon"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
            </table>
            <div class="form-group">
              <button @click="kozosHaztartasbanElokListahozHozzaad" type="button" class="button only-icon">+</button>
            </div>
          </div>
          <div class="col-xs-12">
            <inputbox :disabled="true" :errors="errors" regexp_filter="[0-9]+" id="egyForeJutoNettoHaviJovedelem" label="Egy főre jutó nettó havi jövedelem (Ft)" name="egyForeJutoNettoHaviJovedelem" v-model="form.egyForeJutoNettoHaviJovedelem"/>
          </div>
          <div class="col-xs-12">
            <div class="info-box download">
              <a target="_blank" href="assets/files/rendszeres_szocialis_osztondij_2_sz_melleklet.pdf" title="2. sz melléklet">
                <span class="highlight">2. sz melléklet (Nyilatkozat minta)</span> letöltés
              </a>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <UploadHandler :max_uploaded_files="form.kozosHaztartasbanElokLista.length" @change="(value) => { form.kozosHaztartasbanElokNettoJovedelmeIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="kozosHaztartasbanElokNettoJovedelmeIgazolas" label="Jövedelemigazolások, jogviszony igazolások, egyéb papírok" name="kozosHaztartasbanElokNettoJovedelmeIgazolas" :loaded_files="form.kozosHaztartasbanElokNettoJovedelmeIgazolas"/>
            </div>
          </div>
        </div>

        <div class="row" v-show="egeszsegugyiKiadasokMutat()">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Egészségügyi kiadások
            </h5>
          </div>
          <div class="col-xs-12">
            <inputbox :errors="errors" regexp_filter="[0-9]+" id="egeszsegugyiKiadasokPalyazoReszerol" label="Igazolt egészségügyi kiadások a pályázó részéről (Ft)" name="egeszsegugyiKiadasokPalyazoReszerol" v-model="form.egeszsegugyiKiadasokPalyazoReszerol"/>
          </div>
          <div class="col-xs-12">
            <inputbox :errors="errors" regexp_filter="[0-9]+" id="egeszsegugyiKiadasokCsaladtagjaiReszerol" label="Igazolt egészségügyi kiadások a pályázó családtagjai részéről (Ft)" name="egeszsegugyiKiadasokCsaladtagjaiReszerol" v-model="form.egeszsegugyiKiadasokCsaladtagjaiReszerol"/>
          </div>
          <div class="col-xs-12">
            <div class="info-box download">
              <a target="_blank" href="assets/files/rendszeres_szocialis_osztondij_3_sz_melleklet.pdf" title="3. sz melléklet">
                <span class="highlight">3. sz melléklet (Szakorvosi vélemény (pályázó) minta)</span> letöltés
              </a>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.egeszsegugyiKiadasokPalyazoIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="egeszsegugyiKiadasokPalyazoIgazolas" label="Egészségügyi kiadások pályázó részéről igazolás" name="egeszsegugyiKiadasokPalyazoIgazolas" :loaded_files="form.egeszsegugyiKiadasokPalyazoIgazolas"/>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="info-box download">
              <a target="_blank" href="assets/files/rendszeres_szocialis_osztondij_4_sz_melleklet.pdf" title="4. sz melléklet">
                <span class="highlight">4. sz melléklet (Szakorvosi vélemény (hozzátartozó) minta)</span> letöltés
              </a>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <UploadHandler max_uploaded_files="1" @change="(value) => { form.egeszsegugyiKiadasokCsaladtagokIgazolas = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="egeszsegugyiKiadasokCsaladtagokIgazolas" label="Egészségügyi kiadások pályázó családtagjai részéről igazolás" name="egeszsegugyiKiadasokCsaladtagokIgazolas" :loaded_files="form.egeszsegugyiKiadasokCsaladtagokIgazolas"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Megjegyzés
            </h5>
          </div>
          <div class="col-xs-12">
            <textareabox id="megjegyzes" label="Megjegyzés" name="megjegyzes" v-model="form.megjegyzes"/>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h5 style="margin-top: 0px;" class="form-block-title">
              Hallgatói nyiltakozat
            </h5>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input true-value="1" false-value="0" id="nyilatkozatElfogadas" type="checkbox" v-model="form.nyilatkozatElfogadas"/>
                <label for="nyilatkozatElfogadas">
                  <div class="icon"></div>
                  Büntetőjogi felelősségem teljes tudatában kijelentem, hogy a saját és a hozzátartozóim, illetve a velem egy háztartásban élők jelen adatlapon, valamint a mellékletekben feltüntetett személyes adatai a valóságnak megfelelnek.
                </label>
              </div>
              <div v-if="error.id == 'nyilatkozatElfogadas'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input true-value="1" false-value="0" id="nyilatkozatElfogadas_" type="checkbox" v-model="form.nyilatkozatElfogadas_"/>
                <label for="nyilatkozatElfogadas_">
                  <div class="icon"></div>
                  Tudomásul veszem, hogy a hamis adatok közlése esetén fegyelmi eljárás indulhat ellenem a vonatkozó jogszabályok és a Széchenyi István Egyetem belső szabályzatai alapján, mely a hallgatói jogviszony fegyelmi úton történő megszűnését is eredményezheti.
                </label>
              </div>
              <div v-if="error.id == 'nyilatkozatElfogadas_'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>

          <div class="col-xs-12">
            <div class="form-group">
              <div class="form-checkbox-wrapper">
                <input true-value="1" false-value="0" id="szoctamKisokosElolvasasa" type="checkbox" v-model="form.szoctamKisokosElolvasasa"/>
                <label for="szoctamKisokosElolvasasa">
                  <div class="icon"></div>
                  <div>
                    Elolvastam a <strong>Szoctám Kisokos Hallgatóknak</strong> című tájékoztatót. A dokumentum az alábbi <a target="_blank" href="https://student.sze.hu/downloadmanager/details/id/45580/m/16718">linkről</a> tölthető le.
                  </div>
                </label>
              </div>
              <div v-if="error.id == 'szoctamKisokosElolvasasa'" v-for="(error, i) in errors" class="form-error">{{ error.msg }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <button v-on:click="preSave(0)" :disabled="mentes_folyamatban" type="button" class="button">Mentés</button>
              <button v-on:click="preSave(1)" :disabled="mentes_folyamatban" type="button" class="button">Véglegesít</button>
            </div>
          </div>
        </div>
      </div>

      <div v-show="nezet.tipus == 'hianypotlas_urlap'">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">
              Rendszeres szociális ösztöndíj hiánypótlás ({{ aktiv_hianypotlas_idoszak }})
            </div>
          </div>
        </div>

        <div v-for="(mezo, i) in hianypotlas_mezok">
          <div class="info-box warning" v-html="mezo.megjegyzes"></div>
          <UploadHandler :key="'hp_'+mezo.id" :max_uploaded_files="10" v-on:change="(value) => { mezo.fajlok = value; }" :accepted_files="'image/jpeg,application/pdf,application/x-pdf'" :errors="errors" :id="'hp_'+mezo.id" :label="mezo.megnevezes" :name="'hp_'+mezo.id"/>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <button v-on:click="hianypotlasBekuldes()" :disabled="mentes_folyamatban" type="button" class="button">Beküldés</button>
            </div>
          </div>
        </div>
      </div>

      <div v-show="nezet.tipus == 'info'">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">
              Rendszeres szociális ösztöndíj
            </div>
            <div class="article-text" v-html="nezet.tartalom"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="email_popup.mutat" class="popup-overlay-v2">
      <div class="popup-overlay-v2-inner">
        <div class="popup-overlay-v2-inner-content">
          <div class="popup">
            <button type="button" class="close-btn" @click="emailPopupZar">
              <i class="fa fa-close"></i>
            </button>
            <h1>Email tartalma</h1>
            <div v-html="email_popup.tartalom">
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

export default {
  data: function() {
    return {
      form: {
        tanulmanyiFelev: '',
        nev: '',
        neptunkod: '',
        szuletesiHely: '',
        szuletesiIdo: '',
        anyjaNeve: '',
        telefonszam: '',
        emailCim: '',
        kar: '',
        tagozat: '',
        kepzesNeve: '',
        kepzesSzintje: '',
        kepzesKodja: '',
        kepzesHelye: '',
        penzugyiStatusz: '',
        hallgatoiStatusz: '',
        osztondijindex: 0,
        szakatlag: 0,
        alapTamogatas: 0,
        rendszeresSzocialisOsztondij: 0,
        lakhatasiTamogatas: 0,
        koltsegteritesMersekles: 0,
        allandoLakhelyTavolsagKepzesHelyetolPont: 0,
        allandoLakhelyOrszag: '',
        allandoLakhelyIranyitoszam: '',
        allandoLakhelyTelepules: '',
        allandoLakhelyCim: '',
        allandoLakhelyTavolsagKepzesHelyetolKm: 0,
        utazasiIdoAllandoLakhelyKepzesHelyetolOra: 0,
        utazasiIdoAllandoLakhelyKepzesHelyetolPerc: 0,
        lakhatasiCeluAlberletiSzezodes: 0,
        lakhatasiCeluAlberletiSzezodesIgazolas: [],
        egyhaztartasbanElokIgazolas: [],
        kollegiumiFerohely: 0,
        szocialisRaszorultsagArva: 0,
        szocialisRaszorultsagFelarva: 0,
        szocialisRaszorultsagCsaladfenntarto: 0,
        szocialisRaszorultsagFogyatkossaggalElo: 0,
        szocialisRaszorultsagHalmozottanHatranyosHelyzetu: 0,
        szocialisRaszorultsagNagycsalados: 0,
        szocialisRaszorultsagGyamsagaMegszunt: 0,
        szocialisRaszorultsagHatranyosHelyzetu: 0,
        szocialisRaszorultsagTartosBeteg: 0,
        szocialisRaszorultsagArvaIgazolas: [],
        szocialisRaszorultsagFelarvaIgazolas: [],
        szocialisRaszorultsagCsaladfenntartoIgazolas: [],
        szocialisRaszorultsagFogyatkossaggalEloIgazolas: [],
        szocialisRaszorultsagHalmozottanHatranyosHelyzetuIgazolas: [],
        szocialisRaszorultsagGyamsagaMegszuntIgazolas: [],
        szocialisRaszorultsagHatranyosHelyzetuIgazolas: [],
        szocialisRaszorultsagTartosBetegIgazolas: [],
        kozosHaztartasbanElokNettoJovedelmePont: 0,
        kozosHaztartasbanElokLista: [],
        kozosHaztartasbanElokNettoJovedelmeIgazolas: [],
        egyForeJutoNettoHaviJovedelem: 0,
        egeszsegugyiKiadasokPont: 0,
        egeszsegugyiKiadasokPalyazoReszerol: 0,
        egeszsegugyiKiadasokPalyazoReszerolPont: 0,
        egeszsegugyiKiadasokCsaladtagjaiReszerol: 0,
        egeszsegugyiKiadasokCsaladtagjaiReszerolPont: 0,
        egeszsegugyiKiadasokPalyazoIgazolas: [],
        egeszsegugyiKiadasokCsaladtagokIgazolas: [],
        kivalasztottKepzesKodja: '',
        koltsegteritesMerseklesKiemelkedoTevekenysegIgazolasa: [],
        koltsegteritesMerseklesIndoklas: '',
        felevekSzama: 0,
        megjegyzes: '',
        nyilatkozatElfogadas: 0,
        nyilatkozatElfogadas_: 0,
        szoctamKisokosElolvasasa: 0
      },
      foglalkozas_tipusok: [
        {value: 'Munkavállaló', label: 'Munkavállaló'},
        {value: 'Vállalkozó', label: 'Vállalkozó'},
        {value: 'Nyugdíjas/Rokkantnyugdíjas', label: 'Nyugdíjas/Rokkantnyugdíjas'},
        {value: 'Segélyben részesülő munkanélküli', label: 'Segélyben részesülő munkanélküli'},
        {value: 'Segélyben nem részesülő munkanélküli', label: 'Segélyben nem részesülő munkanélküli'},
        {value: 'Háztartásbeli', label: 'Háztartásbeli'},
        {value: 'Kiskorú/Tanuló', label: 'Kiskorú/Tanuló'},
      ],
      email_popup: {
        mutat: false,
        tartalom: ''
      },
      kitoltesek: [],
      aktiv_idoszak_kitoltes: false,
      k_kitoltes: false,
      konfig: false,
      tanulmanyiFelev: '',
      kepzesek: [],
      errors: [],
      fill_info: '',
      mentes_folyamatban: false,
      aktiv_hianypotlas_idoszak: false,
      hianypotlasra_varo_kitoltes: false,
      hianypotlas_mezok: [],
      nezet: {
        tipus: 'info',
        tartalom: ''
      },
      pdf_generalas_folyamatban: false
    }
  },
  mounted: function() {
    this.init();
  },

  methods: {
    init() {
      const _this = this;

      this.nezet.tipus = 'info';
      this.nezet.tartalom = 'Adatok töltése folyamatban...';

      this.$root.ajax('form/rendszeres_szocialis_osztondij_lekerdezes/', {
        method: 'post',
        data: {
          query: this.$route.query
        },
        success: function(response) {
          if (response.exception_error != false) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = response.exception_error;
            return;
          }

          _this.nezet.tipus = 'kitoltesek';
          _this.kitoltesek = response.kitoltesek;
          _this.tanulmanyiFelev = response.aktiv_idoszak;
          _this.aktiv_idoszak_kitoltes = response.aktiv_idoszak_kitoltes;
          _this.k_kitoltes = response.k_kitoltes;
          _this.hianypotlasra_varo_kitoltes = response.hianypotlasra_varo_kitoltes;
          _this.aktiv_hianypotlas_idoszak = response.aktiv_hianypotlas_idoszak;
        }
      });
    },

    emailPopupNyit(tartalom) {
      this.email_popup.mutat = true;
      this.email_popup.tartalom = tartalom;
    },

    emailPopupZar() {
      this.email_popup.mutat = false;
    },

    konfigAdat(azonosito) {
      if (this.konfig == false)
        return false;

      var adat = false;

      this.konfig.map((k) => {
        if (k.belsoAzonosito == azonosito) {
          adat = k;
        }
      });

      return adat;
    },

    alaptamogatasDisabled() {
      if (['A1 kategóriás külföldi ösztöndíjas (Önköltséges)', 'Egyéb önköltséges', 'Önköltséges', 'Önköltséges (devizás)', 'Önköltséges (devizás) (képzési időn túli)', 'Önköltséges (képzési időn túli)'].indexOf(this.form.penzugyiStatusz) > -1) {
        return true;
      } else {
        return false;
      }
    },

    rendszeresSzocialisOsztondijDisabled() {
      if (['A1 kategóriás külföldi ösztöndíjas (Önköltséges)', 'Egyéb önköltséges', 'Önköltséges', 'Önköltséges (devizás)', 'Önköltséges (devizás) (képzési időn túli)', 'Önköltséges (képzési időn túli)'].indexOf(this.form.penzugyiStatusz) > -1) {
        return true;
      } else {
        return false;
      }
    },

    lakhatasiTamogatasDisabled() {
      if (this.form.kollegiumiFerohely == 1 || ['A1 kategóriás külföldi ösztöndíjas (Önköltséges)', 'Egyéb önköltséges', 'Önköltséges', 'Önköltséges (devizás)', 'Önköltséges (devizás) (képzési időn túli)', 'Önköltséges (képzési időn túli)'].indexOf(this.form.penzugyiStatusz) > -1) {
        return true;
      } else {
        return false;
      }
    },

    koltsegteritesMerseklesDisabled() {
      if (['Állami ösztöndíjas', 'Állami Ösztöndíjas (PHD)', 'Állami ösztöndíjas az Nftv. 47. (6) bekezdés e) és f) pontja szerint', 'Egyéb államilag támogatott', 'Levelező, államilag finanszírozott', 'Államilag finanszírozott', 'Államilag finanszírozott (Máshol)', 'Államilag finanszírozott (PhD)', 'Államilag finanszírozott (képzési időn túli)', 'Államilag támogatott', 'Államilag támogatott (vendéghallgató)'].indexOf(this.form.penzugyiStatusz) > -1) {
        return true;
      } else {
        return false;
      }
    },

    koltsegteritesMerseklesSzocialisAlaponDisabled() {
      if (['Állami ösztöndíjas', 'Állami Ösztöndíjas (PHD)', 'Állami ösztöndíjas az Nftv. 47. (6) bekezdés e) és f) pontja szerint', 'Egyéb államilag támogatott', 'Levelező, államilag finanszírozott', 'Államilag finanszírozott', 'Államilag finanszírozott (Máshol)', 'Államilag finanszírozott (PhD)', 'Államilag finanszírozott (képzési időn túli)', 'Államilag támogatott', 'Államilag támogatott (vendéghallgató)'].indexOf(this.form.penzugyiStatusz) > -1) {
        return true;
      } else {
        return false;
      }
    },

    preSave: function(veglegesit) {
      const _this = this;

      if (veglegesit == 0) {
        this.save(veglegesit);

      } else {
        var haviNettoJovedelemDb = 0;
        var hibak = [];

        this.form.kozosHaztartasbanElokLista.map((lista_elem) => {
          if (parseInt(lista_elem.haviNettoJovedelem) > 0) {
            haviNettoJovedelemDb++;
          }
        });

        if (haviNettoJovedelemDb > this.form.kozosHaztartasbanElokNettoJovedelmeIgazolas.length) {
          hibak.push('- Nincs feltöltve az összes jövedelem igazolás');
        }

        if (hibak.length > 0) {
          swal({
            title: "Figyelem!",
            text: hibak.join('\n'),
            icon: "warning",
          }, function(isConfirm) {
            setTimeout(() => {
              _this.saveConfirm(veglegesit);
            }, 200);
          });

        } else {
          _this.saveConfirm(veglegesit);
        }
      }
    },

    saveConfirm: function(veglegesit) {
      const _this = this;

      swal({
        title: "Biztos véglegesíti a pályázatot?",
        text: "A pályázat véglegesítés után változtatni már nem lehetséges!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Mégsem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.save(veglegesit);
        }
      });
    },

    save: function(veglegesit) {
      const _this = this;
      this.errors = [];

      this.mentes_folyamatban = true;

      this.$root.ajax('form/rendszeres_szocialis_osztondij_ment/', {
        method: 'post',
        data: {
          form: this.form,
          veglegesit: veglegesit,
          query: this.$route.query
        },
        success: function(response) {
          _this.mentes_folyamatban = false;

          if (response.exception_error != false) {
            swal('Hiba', response.exception_error, 'error');
            return;
          }

          if (response.errors.length > 0) {
            _this.errors = response.errors;
            swal('Adatbeviteli hiba', 'Kérjük ellenőrizze az űrlapot.', 'error');
            return;
          }

          if (veglegesit == 0) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = 'Az űrlap kitöltése mentve.';
          }

          if (veglegesit == 1) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = 'Az űrlap kitöltés véglegesítve.';
            _this.nezet.pdf_generalas_gomb = true;
          }
        }
      });
    },

    kepzesValt() {
      const _this = this;

      this.kepzesek.map((kepzes) => {
        if (kepzes.kepzesKodja == _this.form.kivalasztottKepzesKodja) {
          _this.form.kar = kepzes.kar;
          _this.form.tagozat = kepzes.tagozat;
          _this.form.kepzesNeve = kepzes.kepzesNeve;
          _this.form.kepzesSzintje = kepzes.kepzesSzintje;
          _this.form.kepzesKodja = kepzes.kepzesKodja;
          _this.form.kepzesHelye = kepzes.kepzesHelye;
          _this.form.penzugyiStatusz = kepzes.penzugyiStatusz;
          _this.form.hallgatoiStatusz = kepzes.hallgatoiStatusz;
          _this.form.osztondijindex = kepzes.osztondijindex == null ? 0 : kepzes.osztondijindex;
          _this.form.szakatlag = kepzes.szakatlag == null ? 0 : kepzes.szakatlag;
          _this.form.nev = kepzes.nev;
          _this.form.neptunkod = kepzes.neptunkod;
          _this.form.szuletesiHely = kepzes.szuletesiHely;
          _this.form.szuletesiIdo = kepzes.szuletesiIdo;
          _this.form.anyjaNeve = kepzes.anyjaNeve;
          _this.form.telefonszam = kepzes.telefonszam == null ? '' : kepzes.telefonszam;
          _this.form.emailCim = kepzes.emailCim == null ? '' : kepzes.emailCim;
          _this.form.felevekSzama = kepzes.felevekSzama == null ? 0 : kepzes.felevekSzama;
          _this.form.allandoLakhelyOrszag = kepzes.allandoLakhelyOrszag;
          _this.form.allandoLakhelyIranyitoszam = kepzes.allandoLakhelyIranyitoszam;
          _this.form.allandoLakhelyTelepules = kepzes.allandoLakhelyTelepules;
          _this.form.allandoLakhelyCim = kepzes.allandoLakhelyCim;
          _this.form.utazasiIdoAllandoLakhelyKepzesHelyetolOra = kepzes.utazasiIdoAllandoLakhelyKepzesHelyetolOra;
          _this.form.utazasiIdoAllandoLakhelyKepzesHelyetolPerc = kepzes.utazasiIdoAllandoLakhelyKepzesHelyetolPerc;
          _this.form.allandoLakhelyTavolsagKepzesHelyetolKm = kepzes.allandoLakhelyTavolsagKepzesHelyetolKm;
        }
      });

      if (_this.form.kozosHaztartasbanElokLista.length == 0) {
        _this.form.kozosHaztartasbanElokLista.push({
          nev: _this.form.nev,
          rokonsagiFok: '',
          tipus: 'Kiskorú/Tanuló',
          haviNettoJovedelem: '',
          nemElVelemEgyHaztartasban: '0'
        });

      } else {
        _this.form.kozosHaztartasbanElokLista[0].nev = _this.form.nev;
      }

      this.alapTamogatasJeloles();
      this.rendszeresSzocialisOsztondijJeloles();
      this.lakhatasiTamogatasJeloles();
      this.koltsegteritesMerseklesJeloles();
      this.koltsegteritesMerseklesSzocialisAlaponJeloles();
      this.onkoltsegesKollegiumiPontszamJeloles();
    },

    alapTamogatasJeloles() {
      this.form.alapTamogatas = 0;

      if (['Állami ösztöndíjas', 'Állami Ösztöndíjas (PHD)', 'Állami ösztöndíjas az Nftv. 47. (6) bekezdés e) és f) pontja szerint', 'Egyéb államilag támogatott', 'Levelező, államilag finanszírozott', 'Államilag finanszírozott', 'Államilag finanszírozott (Máshol)', 'Államilag finanszírozott (PhD)', 'Államilag finanszírozott (képzési időn túli)', 'Államilag támogatott', 'Államilag támogatott (vendéghallgató)'].indexOf(this.form.penzugyiStatusz) > -1 && this.form.tagozat == 'Nappali' && parseInt(this.form.felevekSzama) == 1) {
        this.form.alapTamogatas = 1;
      }
    },

    rendszeresSzocialisOsztondijJeloles() {
      this.form.rendszeresSzocialisOsztondij = 0;

      if (['Állami ösztöndíjas', 'Állami Ösztöndíjas (PHD)', 'Állami ösztöndíjas az Nftv. 47. (6) bekezdés e) és f) pontja szerint', 'Egyéb államilag támogatott', 'Levelező, államilag finanszírozott', 'Államilag finanszírozott', 'Államilag finanszírozott (Máshol)', 'Államilag finanszírozott (PhD)', 'Államilag finanszírozott (képzési időn túli)', 'Államilag támogatott', 'Államilag támogatott (vendéghallgató)'].indexOf(this.form.penzugyiStatusz) > -1 && this.form.tagozat == 'Nappali') {
        this.form.rendszeresSzocialisOsztondij = 1;
      }
    },

    lakhatasiTamogatasJeloles() {
      this.form.lakhatasiTamogatas = 0;

      //if (['Állami ösztöndíjas', 'Állami Ösztöndíjas (PHD)', 'Állami ösztöndíjas az Nftv. 47. (6) bekezdés e) és f) pontja szerint', 'Egyéb államilag támogatott', 'Levelező, államilag finanszírozott', 'Államilag finanszírozott', 'Államilag finanszírozott (Máshol)', 'Államilag finanszírozott (PhD)', 'Államilag finanszírozott (képzési időn túli)', 'Államilag támogatott', 'Államilag támogatott (vendéghallgató)'].indexOf(this.form.penzugyiStatusz) > -1 && this.form.tagozat == 'Nappali' && this.form.lakhatasiCeluAlberletiSzezodesIgazolas != '' && parseInt(this.form.lakhatasiCeluAlberletiSzezodes) == 1 && parseInt(this.form.kollegiumiFerohely) == 0) {
      if (['Állami ösztöndíjas', 'Állami Ösztöndíjas (PHD)', 'Állami ösztöndíjas az Nftv. 47. (6) bekezdés e) és f) pontja szerint', 'Egyéb államilag támogatott', 'Levelező, államilag finanszírozott', 'Államilag finanszírozott', 'Államilag finanszírozott (Máshol)', 'Államilag finanszírozott (PhD)', 'Államilag finanszírozott (képzési időn túli)', 'Államilag támogatott', 'Államilag támogatott (vendéghallgató)'].indexOf(this.form.penzugyiStatusz) > -1 && this.form.tagozat == 'Nappali' && parseInt(this.form.lakhatasiCeluAlberletiSzezodes) == 1 && parseInt(this.form.kollegiumiFerohely) == 0) {
        this.form.lakhatasiTamogatas = 1;
      }
    },

    koltsegteritesMerseklesJeloles() {
      this.form.koltsegteritesMersekles = 0;

      if (['Egyéb önköltséges', 'Önköltséges', 'Önköltséges (devizás)', 'Önköltséges (devizás) (képzési időn túli)', 'Önköltséges (képzési időn túli)', 'A1 kategóriás külföldi ösztöndíjas (Önköltséges)'].indexOf(this.form.penzugyiStatusz) > -1) {
        this.form.koltsegteritesMersekles = 1;
      }
    },

    koltsegteritesMerseklesSzocialisAlaponJeloles() {
      this.form.koltsegteritesMerseklesSzocialisAlapon = 0;

      if (['Egyéb önköltséges', 'Önköltséges', 'Önköltséges (devizás)', 'Önköltséges (devizás) (képzési időn túli)', 'Önköltséges (képzési időn túli)', 'A1 kategóriás külföldi ösztöndíjas (Önköltséges)'].indexOf(this.form.penzugyiStatusz) > -1) {
        this.form.koltsegteritesMerseklesSzocialisAlapon = 1;
      }
    },

    onkoltsegesKollegiumiPontszamJeloles() {
      this.form.onkoltsegesKollegiumiPontszam = 0;

      if (['Egyéb önköltséges', 'Önköltséges', 'Önköltséges (devizás)', 'Önköltséges (devizás) (képzési időn túli)', 'Önköltséges (képzési időn túli)', 'A1 kategóriás külföldi ösztöndíjas (Önköltséges)'].indexOf(this.form.penzugyiStatusz) > -1) {
        this.form.onkoltsegesKollegiumiPontszam = 1;
      }
    },

    szocialisRaszorultsagNagycsaladosJeloles() {
      var minimalber = parseInt(this.konfigAdat('MINIMALBER').ertek);
      var db = 0;

      // 3 személy minimálbér alatt keres, akkor megadja automatikusan
      this.form.kozosHaztartasbanElokLista.map((l) => {
        if (l.haviNettoJovedelem == '') {
          l.haviNettoJovedelem = 0;
        }

        if (parseInt(l.haviNettoJovedelem) < minimalber) {
          db++;
        }
      });

      if (db >= 3) {
        this.form.szocialisRaszorultsagNagycsalados = 1;
      } else {
        this.form.szocialisRaszorultsagNagycsalados = 0;
      }
    },

    kozosHaztartasbanElokListahozHozzaad() {
      this.form.kozosHaztartasbanElokLista.push({
        nev: '',
        rokonsagiFok: '',
        tipus: 'Munkavállaló',
        haviNettoJovedelem: 0,
        nemElVelemEgyHaztartasban: '0'
      });
      this.egyForeJutoNettoHaviJovedelemKalkulacio();
    },

    kozosHaztartasbanElokListabolTorol(index) {
      this.form.kozosHaztartasbanElokLista.splice(index, 1);
      this.egyForeJutoNettoHaviJovedelemKalkulacio();
    },

    egyForeJutoNettoHaviJovedelemKalkulacio() {
      var osszesen = 0;
      var egy_haztartasban_ossz_szemely = 0;

      this.form.kozosHaztartasbanElokLista.map((l) => {
        if (l.haviNettoJovedelem == '') {
          l.haviNettoJovedelem = 0;
        }

        if (parseInt(l.nemElVelemEgyHaztartasban) == 0) {
          osszesen += parseInt(l.haviNettoJovedelem);
          egy_haztartasban_ossz_szemely++;
        }
      });

      this.form.egyForeJutoNettoHaviJovedelem = Math.round(osszesen / egy_haztartasban_ossz_szemely);

      this.egeszsegugyiKiadasokBeallitas();
      this.szocialisRaszorultsagNagycsaladosJeloles();
    },

    egeszsegugyiKiadasokBeallitas() {
      if (this.form.egyForeJutoNettoHaviJovedelem <= 10) {
        this.form.egeszsegugyiKiadasokPalyazoReszerol = 0;
        this.form.egeszsegugyiKiadasokCsaladtagjaiReszerol = 0;
        this.form.egeszsegugyiKiadasokPalyazoIgazolas = [];
        this.form.egeszsegugyiKiadasokCsaladtagokIgazolas = [];
      }
    },

    egeszsegugyiKiadasokMutat() {
      if (this.form.egyForeJutoNettoHaviJovedelem > 10) {
        return true;
      } else {
        return false;
      }
    },

    pdfGeneralas(id, mentett_vagy_veglegesitett) {
      const _this = this;

      this.pdf_generalas_folyamatban = true;

      this.$root.ajax('form/rendszeres_szocialis_osztondij_pdf_gen/', {
        method: 'post',
        data: {
          id: id,
          mentett_vagy_veglegesitett: mentett_vagy_veglegesitett,
          query: this.$route.query
        },
        success: function(response) {
          _this.pdf_generalas_folyamatban = false;

          if (response.exception_error != false) {
            swal('Hiba', response.exception_error, 'error');
            return;
          }

          if (response.pdf_fajl != undefined) {
            window.open(location.protocol + '//' + location.host + '/assets/urlap_kitoltesek/' + response.pdf_fajl);
          }
        }
      });
    },

    palyazatUrlapMegjelenites() {
      const _this = this;

      this.nezet.tipus = 'info';
      this.nezet.tartalom = 'Űrlap betöltése folyamatban...';

      this.$root.ajax('form/rendszeres_szocialis_osztondij_urlap/', {
        method: 'post',
        data: {
          query: this.$route.query
        },
        success: function(response) {
          if (response.exception_error != false) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = response.exception_error;
            return;
          }

          if (response.veglegesitve) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = 'Az űrlap kitöltés véglegesítve.';
            _this.nezet.pdf_generalas_gomb = true;
            return;
          }

          if (response.kepzesek != undefined) {
            _this.kepzesek = response.kepzesek;
            _this.form.kivalasztottKepzesKodja = _this.kepzesek[0].value;
            _this.kepzesValt();
          }

          if (response.form != undefined) {
            _this.form = response.form;
            _this.form.kivalasztottKepzesKodja = response.form.kepzesKodja;

            _this.kepzesek.map((kepzes) => {
              if (kepzes.kepzesKodja == _this.form.kivalasztottKepzesKodja) {
                _this.form.felevekSzama = kepzes.felevekSzama;
              }
            });
          }

          if (response.kollegiumiFerohely != undefined) {
            _this.form.kollegiumiFerohely = response.kollegiumiFerohely;
          }

          if (response.tanulmanyiFelev != undefined) {
            _this.form.tanulmanyiFelev = response.tanulmanyiFelev;
            _this.tanulmanyiFelev = response.tanulmanyiFelev;
          }

          if (_this.form.kozosHaztartasbanElokLista.length > 0) {
            var foglalkozas_tipusok = [];

            _this.foglalkozas_tipusok.map((ft) => {
              foglalkozas_tipusok.push(ft.value);
            });

            _this.form.kozosHaztartasbanElokLista.map((item) => {
              if (foglalkozas_tipusok.indexOf(item.tipus) < 0) {
                _this.foglalkozas_tipusok.push({value: item.tipus, label: item.tipus});
                foglalkozas_tipusok.push(item.tipus);
              }
            });
          }

          _this.konfig = response.konfig;
          _this.nezet.tipus = 'urlap';
        }
      });
    },

    hianypotlasUrlapMegjelenites() {
      const _this = this;

      this.nezet.tipus = 'info';
      this.nezet.tartalom = 'Űrlap betöltése folyamatban...';

      this.$root.ajax('form/rendszeres_szocialis_osztondij_hianypotlas_urlap/', {
        method: 'post',
        data: {
          query: this.$route.query
        },
        success: function(response) {
          if (response.exception_error != false) {
            _this.nezet.tipus = 'info';
            _this.nezet.tartalom = response.exception_error;
            return;
          }

          if (response.hianypotlas_mezok != undefined) {
            _this.hianypotlas_mezok = response.hianypotlas_mezok;
          }

          _this.nezet.tipus = 'hianypotlas_urlap';
        }
      });
    },

    hianypotlasBekuldes() {
      const _this = this;

      swal({
        title: "Biztos beküldi a hiánypótlást?",
        text: "Hiánypótlás csak egyszer küldhető be!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Mégsem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.mentes_folyamatban = true;
          _this.errors = [];

          _this.$root.ajax('form/rendszeres_szocialis_osztondij_hianypotlas_ment/', {
            method: 'post',
            data: {
              hianypotlas_mezok: _this.hianypotlas_mezok,
              query: _this.$route.query
            },
            success: function(response) {
              _this.mentes_folyamatban = false;

              if (response.exception_error != false) {
                swal('Hiba', response.exception_error, 'error');
                return;
              }

              if (response.errors.length > 0) {
                _this.errors = response.errors;
                swal('Adatbeviteli hiba', 'Kérjük ellenőrizze az űrlapot.', 'error');
                return;
              }

              _this.nezet.tipus = 'info';
              _this.nezet.tartalom = 'Hiánypótlás beküldve.';
            }
          });
        }
      });
    },

    palyazatModositasa() {
      const _this = this;
      this.errors = [];

      swal({
        title: "Pályázat módosítása",
        text: "A pályázat az aktív időszakban mentett állapotba kerül, és továbbra is módosítható lesz az aktív időszakban. Biztos benne, hogy végrehajtja a műveletet?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Mégsem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.mentes_folyamatban = true;

          _this.$root.ajax('form/rendszeres_szocialis_osztondij_palyazat_modositasa/', {
            method: 'post',
            data: {
              query: _this.$route.query
            },
            success: function(response) {
              _this.mentes_folyamatban = false;

              if (response.exception_error != false) {
                swal('Hiba', response.exception_error, 'error');
                return;

              } else {
                _this.palyazatUrlapMegjelenites();
              }
            }
          });
        }
      });
    },

    palyazatElfogadas() {
      const _this = this;
      this.errors = [];

      swal({
        title: "Pályázat elfogadása",
        text: "Elfogadja a kollégiumhoz leadott pályázat eredményét a rendszeres szociális támogatási időszakra? A pályázat a továbbiakban nem módosítható. Biztosan végrehajtja a műveletet?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Mégsem",
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: false
      }, function(isConfirm) {
        if (isConfirm) {
          _this.mentes_folyamatban = true;

          _this.$root.ajax('form/rendszeres_szocialis_osztondij_palyazat_elfogadas/', {
            method: 'post',
            data: {
              query: _this.$route.query
            },
            success: function(response) {
              _this.mentes_folyamatban = false;

              if (response.exception_error != false) {
                swal('Hiba', response.exception_error, 'error');
                return;

              } else {
                swal('Siker', 'A pályzat elfogadva', 'success');
                _this.init();
              }
            }
          });
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// rendszeres_szocialis_osztondij.vue?0bb15f2c